import PropTypes from 'prop-types';

export const ItemGADetailsPropTypes = PropTypes.shape({
  brand: PropTypes.string,
  businessUnit: PropTypes.string,
  category: PropTypes.string,
  checkFitment: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  partNumber: PropTypes.string,
  list: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.string,
  productWeight: PropTypes.string,
  position: PropTypes.number,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  relatedModel: PropTypes.string
});
